import { Box, Typography } from '@mui/material'

import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import IconButton from '@mui/material/IconButton'

const UserProfileTitle = ({ user, orgIcon, onClose }) => (
  <Box
    sx={{
      pt: 1,
      pb: 3.5,
      px: 3,
      background: 'linear-gradient(135deg,#1976d2 0%,#42a5f5 100%)',
      color: 'white',
    }}>
    <IconButton
      onClick={onClose}
      size='small'
      sx={{
        position: 'absolute',
        top: 14,
        right: 14,
        color: 'white',
        bgcolor: 'rgba(255,255,255,.12)',
        '&:hover': {
          bgcolor: 'rgba(255,255,255,.22)',
        },
      }}>
      <CloseRoundedIcon />
    </IconButton>
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2.5,
        py: 0.5,
      }}>
      <Box
        sx={{
          width: 50,
          height: 50,
          borderRadius: '50%',
          bgcolor: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 6px 20px rgba(0,0,0,.2)',
        }}>
        <Box
          component='img'
          src={orgIcon}
          sx={{
            width: 44,
            height: 44,
            objectFit: 'contain',
          }}
        />
      </Box>

      <Box>
        <Typography
          variant='h6'
          sx={{
            fontWeight: 700,
          }}>
          {user?.name}
        </Typography>

        <Typography
          sx={{
            mt: 0.5,
            fontSize: 13,
            opacity: 0.9,
          }}>
          ● Active Account
        </Typography>
      </Box>
    </Box>
  </Box>
)

export default UserProfileTitle
